import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteFromCart,
  decreaseQuantity,
  addToCart,
} from '../../../store/slices/cart-slice';

const MenuCart = () => {
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);

  // Parse price to ensure it's a number
  const parsePrice = (price) => {
    const numPrice = parseFloat(price);
    return isNaN(numPrice) ? 0 : numPrice;
  };

  // Calculate cart totals
  const cartTotalPrice = cartItems.reduce(
    (total, item) => total + parsePrice(item.price) * item.quantity,
    0
  );

  // Handle item removal
  const handleRemoveFromCart = (item) => {
    dispatch(deleteFromCart(item.cartItemId));
  };

  // Handle quantity decrease
  const handleDecreaseQuantity = (item) => {
    if (item.quantity > 1) {
      dispatch(decreaseQuantity(item));
    } else {
      dispatch(deleteFromCart(item.cartItemId));
    }
  };

  // Handle quantity increase
  const handleAddToCart = (item) => {
    dispatch(
      addToCart({
        ...item,
        quantity: 1,
      })
    );
  };

  // Get image URL safely
  const getImageUrl = (item) => {
    if (
      item &&
      item.images &&
      Array.isArray(item.images) &&
      item.images.length > 0
    ) {
      return item.images[0].image_url;
    }
    return process.env.PUBLIC_URL + '/assets/img/default-placeholder.png';
  };

  return (
    <div className='shopping-cart-content'>
      {cartItems && cartItems.length > 0 ? (
        <>
          <ul>
            {cartItems.map((item, key) => (
              <li className='single-shopping-cart' key={key}>
                <div className='shopping-cart-img'>
                  <Link to={process.env.PUBLIC_URL + '/product/' + item.id}>
                    <img
                      alt={item.name || 'Product'}
                      src={getImageUrl(item)}
                      className='img-fluid'
                    />
                  </Link>
                </div>
                <div className='shopping-cart-title'>
                  <h4>
                    <Link to={process.env.PUBLIC_URL + '/product/' + item.id}>
                      {item.name}
                    </Link>
                  </h4>
                  <div className='cart-item-variation'>
                    {item.selectedProductSize && (
                      <span>Size: {item.selectedProductSize}</span>
                    )}
                    {item.selectedProductColor && (
                      <span>Color: {item.selectedProductColor}</span>
                    )}
                  </div>
                  <div className='item-quantity-controller'>
                    <button
                      onClick={() => handleDecreaseQuantity(item)}
                      className='qty-btn'
                    >
                      -
                    </button>
                    <span className='qty-value'>{item.quantity}</span>
                    <button
                      onClick={() => handleAddToCart(item)}
                      className='qty-btn'
                    >
                      +
                    </button>
                  </div>
                  <h6>
                    ${(parsePrice(item.price) * item.quantity).toFixed(2)}
                  </h6>
                </div>
                <div className='shopping-cart-delete'>
                  <button onClick={() => handleRemoveFromCart(item)}>
                    <i className='fa fa-times-circle' />
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <div className='shopping-cart-total'>
            <h4>
              Total :{' '}
              <span className='shop-total'>${cartTotalPrice.toFixed(2)}</span>
            </h4>
          </div>
          <div className='shopping-cart-btn btn-hover text-center'>
            <Link className='default-btn' to={process.env.PUBLIC_URL + '/cart'}>
              view cart
            </Link>
            <Link
              className='default-btn'
              to={process.env.PUBLIC_URL + '/checkout'}
            >
              checkout
            </Link>
          </div>
        </>
      ) : (
        <p className='text-center empty-cart-message'>No items added to cart</p>
      )}
    </div>
  );
};

export default MenuCart;
